import React from 'react';
import { TablePagination, useMediaQuery, useTheme } from '@mui/material';

import { useCCTableContext } from './cc-table.context';

export const CCTablePagination = () => {
  const theme = useTheme();
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  const { filteredRows, page, rowsPerPage, updateTableStatus } = useCCTableContext();

  const handleChangePage = (event: any, page: number) => {
    updateTableStatus({ page });
  };

  const handleChangeRowsPerPage = (event: any) => {
    updateTableStatus({ page: 0, rowsPerPage: parseInt(event.target.value, 10) });
  };

  return (
    <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      count={filteredRows.length}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelRowsPerPage={down_sm ? '' : 'Rows per page'}
      sx={{ margin: 'auto' }}
    />
  );
};
